export const TOTAL_TEXT = (totalPassenger: number | null) =>
  `Total ${
    totalPassenger
      ? `(${totalPassenger} ${totalPassenger > 1 ? "travelers" : "traveler"})`
      : ""
  }`;
